/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Leading_SpacesInputs */

const en_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Leading Spaces`)
};

const fr_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les espaces en début`)
};

const de_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Führende Leerzeichen entfernen`)
};

const it_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi gli spazi iniziali`)
};

const ru_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалите пробелы в начале предложения.`)
};

const es_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar espacios iniciales`)
};

const zh_cn2_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除前导空格`)
};

const ja_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先頭のスペースを削除`)
};

const hi_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभिक रिक्त स्थान हटाएँ`)
};

const pt_pt2_remove_leading_spaces = /** @type {(inputs: Remove_Leading_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover espaços iniciais`)
};

/**
* | output |
* | --- |
* | "Remove Leading Spaces" |
*
* @param {Remove_Leading_SpacesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_leading_spaces = /** @type {((inputs?: Remove_Leading_SpacesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Leading_SpacesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_leading_spaces(inputs)
	if (locale === "de") return de_remove_leading_spaces(inputs)
	if (locale === "it") return it_remove_leading_spaces(inputs)
	if (locale === "ru") return ru_remove_leading_spaces(inputs)
	if (locale === "es") return es_remove_leading_spaces(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_leading_spaces(inputs)
	if (locale === "ja") return ja_remove_leading_spaces(inputs)
	if (locale === "hi") return hi_remove_leading_spaces(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_leading_spaces(inputs)
	return en_remove_leading_spaces(inputs)
});